module.exports = __webpack_public_path__ + "img/telegram_chat_vip.f24056d0.png";